<template>
    <div class="MAM_editInfo">
        <el-dialog :visible="true" @close="handleClose" :close-on-click-modal="false" >
            <el-card class="box-card" shadow="hover">
                <div class="demo-input-suffix_box">
                    <div class="demo-input-suffix">所属代理：{{data.agent_name}}</div>
                    <div class="demo-input-suffix">终端类型：{{data.brand_name}}</div>
                    <div class="demo-input-suffix">设备型号：{{data.term_type}}</div>
                    <div class="demo-input-suffix">设备编号：{{data.sn}}</div>
                    <div class="demo-input-suffix">是否激活：{{data.is_active}}</div>
                    <div class="demo-input-suffix">是否绑定：{{data.is_bind}}</div>
                    <div class="demo-input-suffix">激活截止日期：{{data.endtime}}</div>
                </div>


                <div class="demo-input-suffix">
                    延迟天数：<el-input class="input" v-model="dayNum" type="number" placeholder="请输入内容" @input="changeInput"></el-input>
                </div>
                <div class="demo-input-suffix" v-if="dayNum > 0">延迟至：{{editTimeTxt}}</div>
                <div class="edit_btn">
                    <el-button type="primary" class="primary" @click="editTime()">修改</el-button>
                </div>

            </el-card>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "MAM_activShow",
        props: {
            array:{
                type:[Object],
                default: function () {
                    return  {};
                }
            }
        },
        data() {
            return {
                data:'',
                dayNum:0,//延迟天数
                editTimeTxt:'',//延迟后的天数
            }
        },
        mounted() {
            this.data = this.array
        },
        methods: {
            handleClose(res){
                this.$emit('infoClose')
            },//监听input改变事件
            changeInput(res){
                res = parseInt(res)
                if(res <= 0){this.dayNum = 0}
                if(res >= 999){this.dayNum = 999}
                this.dayNum = parseInt(this.dayNum)

                //格式化延长后的时间
                var date = new Date(this.data.endtime);
                var time = parseInt(date.getTime() + (parseInt(this.dayNum) * 86400000))
                if(this.dayNum > 0){
                    this.editTimeTxt = this.formatDate(time)
                }

            },
            //修改事件
            editTime(){
                var obj = this.data
                obj.edit_activ_time = this.dayNum

                this.$api.post('terminal/delayActivInfo', obj, res => {
                    if(res.code == 0){
                        this.$message.success(res.data);
                        this.$emit('infoClose')
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //格式化时间
            formatDate(date) {
                var date = new Date(date);
                var YY = date.getFullYear() + '-';
                var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                return YY + MM + DD;
            }
        }
    };
</script>
<style scoped lang="scss">
    .MAM_editInfo {
        font-size: 12px;
        .el-input__inner,
        .tips {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }

        ::v-deep .el-form-item__label {
            padding: 0;
            font-size: 12px;
        }
        .titleTip {
            padding: 10px 10px;
            background-color: #ecf8ff;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #50bfff;
            margin: 10px 0;
        }
        .title p {
            font-size: 12px;
            :first-child {
                font-weight: 700;
            }
        }
    }
    .setUserRate {
        ::v-deep .el-form-item__label {
            font-size: 12px;
            font-weight: 700;
        }
        ::v-deep .el-input__inner {
            width: 150px;
        }
        ::v-deep .el-dialog {
            height: 80%;
            .el-dialog__body {
                height: 82%;
                overflow: auto;
            }
        }
        .type_title {
            margin: 10px 0;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #40b8ff;
            padding: 0 0 0 10px;
        }
    }
    .input{
        width: 30%;
    }
    .demo-input-suffix{margin-bottom:20px}
    .edit_btn{display:flex;justify-content:center;margin-top:10%;}
    .demo-input-suffix_box{display:flex;flex-wrap:wrap}
    .demo-input-suffix_box .demo-input-suffix{width:50%;}
</style>